import { useEffect, useState } from 'react';

export const useCoolDown = (timeout: number, timeSinceLastShown: number) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    setShouldShow(new Date().valueOf() - timeout > timeSinceLastShown);
  }, [timeout, timeSinceLastShown]);

  return shouldShow;
};
